module.exports = __webpack_public_path__ + "img/UTBEAR-7.189b4ccc.jpg";